<template>
    <div class="yq-section-config">
        <div class="yq-section-config-head">
            <div class="yq-section-config-name">栏目推送配置</div>
            <div class="yq-section-config-toolbar">
                <el-link @click="returnBack" :underline="false" icon="el-icon-back">返回</el-link>
            </div>
        </div>
        <div class="yq-section-config-content" style="display: block">
            <el-form class="search-form" inline :model="searchModel">
                <el-form-item>
                    <el-input v-model="searchModel.userName" style="width: 120px;" placeholder="用户名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">搜索</el-button>
                    <el-button type="primary" @click="addRow">添加推送用户</el-button>
                    <el-switch style="margin-left: 10px;" class="yq-el-switch" v-model="editNotifyData"
                               active-text="人工筛选推送数据" active-color="#13ce66" inactive-color="#ff4949"
                               @change="onEditNotifyDataChange"></el-switch>
                </el-form-item>
            </el-form>
            <div v-if="data">
                <el-table class="yq-table" :data="data.content" style="width: 100%">
                    <el-table-column
                            type="index"
                            :index="indexMethod">
                    </el-table-column>
                    <el-table-column
                            prop="user.name"
                            label="推送用户" width="200">
                    </el-table-column>
                    <el-table-column
                            label="添加时间" width="250">
                        <pretty-date-time slot-scope="scope" :value="scope.row.createdAt"/>
                    </el-table-column>
                    <el-table-column
                            label="操作">
                        <template slot-scope="scope">
                            <el-link icon="el-icon-delete" @click="deleteRow(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        layout="prev, pager, next" background
                        :total="data.totalElements" :current-page="data.number+1"
                        @current-change="fetchData($event)">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="添加推送用户" :visible.sync="addDialog.visible">
            <el-form ref="addForm" :model="addDialog.model" label-width="120px" :rules="addDialog.rules">
                <el-form-item label="选择用户" prop="user">
                    <user-select value-type="object" v-model="addDialog.model.user"></user-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addDialog.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitAddForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import sectionService from '../../service/section'

    export default {
        name: "SectionSubscriptionConfig",
        props: {
            sectionId: Number
        },
        data() {
            const checkUser = (rule, value, callback) => {
                if (value) {
                    sectionService.checkUserSectionSubscription(value.id, this.sectionId).then(response => {
                        if (response.data) {
                            callback(new Error('该用户已存在'));
                        } else {
                            callback();
                        }
                    }).catch(() => {
                        callback(new Error('校验出错'));
                    })
                } else {
                    callback();
                }
            }
            return {
                searchModel:{
                    userName: null
                },
                searchParams: {
                    userName: null
                },
                data: null,
                addDialog:{
                    visible: false,
                    model: {
                        user: null
                    },
                    rules: {
                        user: [
                            {required: true, message: '请选择用户', trigger: 'blur'},
                            {validator: checkUser, trigger: 'blur'}
                        ]
                    }
                },
                editNotifyData: null
            }
        },
        created() {
            this.init()
        },
        watch: {
            sectionId() {
                this.init()
            }
        },
        methods: {
            async init() {
                this.editNotifyData = (await sectionService.getSection(this.sectionId)).data.editNotifyData
                await this.search()
            },
            async search(){
                this.searchParams = JSON.parse(JSON.stringify(this.searchModel))
                await this.fetchData(1)
            },
            async fetchData(page) {
                const params = Object.assign({sectionId:this.sectionId, page: page - 1, size: 10},this.searchParams)
                const response = await sectionService.listUserSectionSubscriptionSummaries(params)
                this.data = response.data
            },
            indexMethod(index) {
                return this.data.number * this.data.size + index + 1
            },
            addRow(){
                this.addDialog.model.user = null
                this.addDialog.visible=true
                if(this.$refs.addForm){
                    this.$refs.addForm.clearValidate()
                }
            },
            async submitAddForm(){
                try {
                    await this.$refs.addForm.validate()
                } catch (e) {
                    return
                }
                await sectionService.addUserSectionSubscription({
                    sectionId: this.sectionId,
                    userId: this.addDialog.model.user.id
                })
                this.addDialog.visible=false
                await this.fetchData(this.data.number+1)
            },
            async deleteRow(row){
                try {
                    await this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                } catch (e) {
                    return
                }
                try {
                    await sectionService.deleteUserSectionSubscriptionById(row.id)
                } catch (e) {
                    this.$message({
                        type: 'error',
                        message: '删除失败!'
                    })
                    throw e
                }
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                })
                await this.fetchData(this.data.number+1)
            },
            async returnBack() {
                this.$emit('close')
            },
            async onEditNotifyDataChange(val){
                try {
                    await sectionService.updateSectionNotifyConfig({
                        id: this.sectionId,
                        editNotifyData: val
                    })
                } catch (e) {
                    this.$message.error('修改栏目推送配置失败');
                    this.editNotifyData = !val
                    throw e
                }

            }
        }
    }
</script>

<style scoped>

</style>
